import React from 'react';
import { Heading } from '..';
import css from '../../containers/ListingPage/ListingPage.module.css';


import { FaHeartbeat, FaDog, FaCut, FaMedal } from 'react-icons/fa';
import { RiMentalHealthFill } from 'react-icons/ri';
import { GiSniffingDog, GiComb, GiScissors } from 'react-icons/gi';
import { FiScissors } from "react-icons/fi";
import { TbFileScissors } from "react-icons/tb";
import { PiScissorsFill } from "react-icons/pi";


const certificationDisplayData = { 
  pet_first_aid_cpr: {
    name: 'Pet First Aid & CPR',
    icon: <FaHeartbeat />,
  },
  animal_behavior_handling_care: {
    name: 'Animal Behavior, Handling & Care',
    icon: <RiMentalHealthFill />,
  },
  dog_training: {
    name: 'Dog Training',
    icon: <GiSniffingDog />,
  },
  certified_pet_groomer: {
    name: 'Certified Pet Groomer (CPG)',
    icon: <FaCut />,
  },
  certified_master_groomer: {
    name: 'Certified Master Groomer (CMG)',
    icon: <TbFileScissors style={{fill:'none'}} />,
  },
  certified_professional_groomer: {
    name: 'Certified Professional Groomer (CPG)',
    icon: <GiComb />,
  },
  advanced_groomer: {
    name: 'Certified Advanced Professional Groomer (CAPG)',
    icon: <FiScissors style={{fill:'none'}} />,
  },
  international_groomer: {
    name: 'International Certified Master Groomer (ICMG)',
    icon: <PiScissorsFill />,
  },
};

const SectionProfessionalCertifications = props => {
  const { heading, selectedOptions = [] } = props;

  if (!heading || selectedOptions.length === 0) {
    return null;
  }

  return (
    <section className={css.sectionCleaningFacilities}>
      <Heading as="h2" rootClassName={css.sectionHeading}>
        {heading}
      </Heading>
      <ul className={css.petTypeList}>
        {selectedOptions.map(option => {
          const certification = certificationDisplayData[option];
          return (
            <li key={option} className={css.multiEnumItem}>
              <span className={css.facilityIcon}>{certification?.icon}</span>
              <span>{certification?.name || option}</span>
            </li>
          );
        })}
      </ul>
    </section>
  );
};

export default SectionProfessionalCertifications;
